module.exports = __webpack_public_path__ + "static/media/login-to-kcc.8c605a9c.mp4";